import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { FeeScheduleCategoryMaskedCurrency } from "work/_shared/masked-fields";

export type FeeScheduleCategoryCommandPayload = {
  name?: string;
  description?: string;
  billingCode?: string;
  feeRate?: number;
  feeCurrency?: string;
  feeUnit?: string;
  id?: string;
};
export default class FeeScheduleCategoryCommand {
  id?: string;
  name?: string;
  description?: string;
  billingCode?: string;
  feeRate?: number;
  feeCurrency?: string;
  feeUnit?: string;

  constructor(category: FeeScheduleCategory | FeeScheduleCategoryMaskedCurrency) {
    if (!category.name) throw new Error("Fee Schedule Category name is required");
    this.id = category.id?.value;
    this.name = category.name.value;
    this.description = category.description?.value;
    this.billingCode = category.billingCode?.value;
    if (category instanceof FeeScheduleCategoryMaskedCurrency) {
      return;
    }
    this.feeRate = category.fee?.rate?.amount;
    this.feeCurrency = category.fee?.rate?.currency;
    this.feeUnit = category.fee?.unit ?? undefined;
  }

  public get payload(): FeeScheduleCategoryCommandPayload {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      billingCode: this.billingCode,
      feeRate: this.feeRate,
      feeCurrency: this.feeCurrency,
      feeUnit: this.feeUnit,
    };
  }
}
